import { render, staticRenderFns } from "./stardisplay.vue?vue&type=template&id=2b3a345e&"
import script from "./stardisplay.vue?vue&type=script&lang=js&"
export * from "./stardisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b3a345e')) {
      api.createRecord('2b3a345e', component.options)
    } else {
      api.reload('2b3a345e', component.options)
    }
    module.hot.accept("./stardisplay.vue?vue&type=template&id=2b3a345e&", function () {
      api.rerender('2b3a345e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2sU485883QTbl/JS/comp/stardisplay.vue"
export default component.exports